import { SvgIcon } from '@mui/material'
import * as React from 'react'

interface Props {
  style?: React.CSSProperties
}

const ChristmasTreeSvg: React.FC<Props> = ({ style }): React.ReactElement => {
  return (
    <SvgIcon viewBox="0 0 64 64" style={style}>
      <svg viewBox="0 0 64 64" width="32" height="32">
        <defs>
          <style>{'.cls-3{fill:#E6564C}.cls-7{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:2px}'}</style>
        </defs>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g id="Layer_1" data-name="Layer 1">
            <g id="Vector">
              <path
                d="M25.46 51.96h13.07v10.09H25.46z"
                style={{
                  fill: '#bb7444',
                }}
              />
              <path d="M37.57 7.52a5.57 5.57 0 1 1-11.14 0 5.57 5.57 0 1 1 11.14 0z" className="cls-3" />
              <path
                d="M51.37 52H12.63a4 4 0 0 1-2.82-6.79l8-8h28.33l8 8A4 4 0 0 1 51.37 52zm-5-14.87H17.62a2.94 2.94 0 0 1-2.08-5l7-7h19l7 7a3 3 0 0 1-2.17 5zm-2.54-12.01H20.16A2.42 2.42 0 0 1 18.45 21L28 11.41a5.57 5.57 0 0 0 8 0L45.55 21a2.43 2.43 0 0 1-1.72 4.12z"
                style={{
                  fill: '#408830',
                }}
              />
              <g
                style={{
                  opacity: 0.2,
                }}
              >
                <path
                  d="M49 39.94 8.66 48.15a4 4 0 0 0 2.57 3.56l41.12-8.38zM18 29.63l29 7.44a3 3 0 0 0 2.3-3.54l-28-7.18zm2.16-4.51h1.06c5.84-2.32 14-5.52 20.54-7.93l-3.11-3.12c-7.06 2.64-15.44 5.93-20.85 8.1a2.42 2.42 0 0 0 2.36 2.95z"
                  style={{
                    fill: '#231f20',
                  }}
                />
              </g>
              <circle cx={37.49} cy={21.88} r={1.45} className="cls-3" />
              <circle cx={20.94} cy={33.61} r={1.53} className="cls-3" />
              <circle cx={44.4} cy={48.15} r={1.45} className="cls-3" />
            </g>
            <g id="Line">
              <path d="M28 62.05h-2.54V51.96h13.07v10.09H30m7.57-54.53a5.57 5.57 0 1 1-11.14 0 5.57 5.57 0 1 1 11.14 0z" className="cls-7" />
              <path
                d="m14 41 3.85-3.85h28.29l8 8A4 4 0 0 1 51.37 52H12.63a4 4 0 0 1-2.82-6.79L11 44m35.37-6.87H17.62a2.94 2.94 0 0 1-2.08-5l7-7h19l7 7a3 3 0 0 1-2.17 5zm-2.54-12.01H20.16A2.42 2.42 0 0 1 18.45 21L28 11.41a5.57 5.57 0 0 0 8 0L45.55 21a2.43 2.43 0 0 1-1.72 4.12z"
                className="cls-7"
              />
            </g>
            <g
              style={{
                mixBlendMode: 'multiply',
              }}
            >
              <path
                id="Shadow"
                d="m54.18 45.17-1.83-1.84L49 39.94l-2.82-2.81h.23a2.9 2.9 0 0 0 1.16-.24 2.62 2.62 0 0 0 .94-.66 3.07 3.07 0 0 0 .76-1.5 3 3 0 0 0 0-1.15 2.94 2.94 0 0 0-.8-1.43l-7-7h2.35A2.43 2.43 0 0 0 45.55 21l-3.79-3.79-3.11-3.12L36 11.41a5.5 5.5 0 0 0 1.59-3.89A5.55 5.55 0 0 0 32.11 2c2 3.74 2.81 8.17 3.54 12.42.85 4.93 1.7 10 1 14.92A25.2 25.2 0 0 1 17.63 50c-2.15.47-4.36.65-6.46 1.28l-.54.19h.06a4 4 0 0 0 1.94.5h12.84v10.08h13.07V52h12.83a4 4 0 0 0 2.81-6.83z"
                style={{
                  opacity: 0.25,
                  mixBlendMode: 'multiply',
                }}
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  )
}
export default ChristmasTreeSvg
